<template>
  <v-app>
    <core-systembar />

    <core-app-bar />

    <core-drawer />

    <core-view />

    <core-footer />
  </v-app>
</template>

<script>
  export default {
    components: {
      CoreAppBar: () => import('@/components/core/AppBar'),
      CoreDrawer: () => import('@/components/core/Drawer'),
      CoreFooter: () => import('@/components/core/Footer'),
      CoreSystembar: () => import('@/components/core/Systembar'),
      CoreView: () => import('@/components/core/View')
    }
  }
</script>
